import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import AchievementsDataset from './datasets/achievements_dataset';
import BadgesInfoDataset from './badgesDatasets/badges_info_dataset';
import AwardImageCard from './award_image_card';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import AwardInfoModal from './award_info_modal';
import getTrophyInfo from '../../objects/CommonUse/get_trophy_info';
import ConfigFile from '../../datasets/config_file';


class AwardModal extends Component {
            constructor(props) {
              super(props);
              this.gameInfo = this.props.gameInfo;
              this.state={
                nbrPerRow: 4,
                badgesPerTopic: 2,
                openAwardInfo: false,
                subProcess: "leaderBoard",
                maxNbrBadges: ConfigFile.gameBoard.maxBadges,
        };
        this.initializeDisplayInfo();
       
           
    }

    initializeDisplayInfo(){
        this.achievementArr = [];
        this.processBadges();
        this.processAchievements();
    }

    processBadges(){
        let badgesList = BadgesInfoDataset;
        let rowNbr = 0;
        let achievementObj = {};
        let shelfObj = {};
        let prevBadgeCode = "";
        let badgePartCount = 0;
        let fullBadgeCode = "";
   
        for (let i=0; i<badgesList.length; i++){
            const checkRow = rowNbr * this.state.nbrPerRow * 2;
            if (i === checkRow){
                achievementObj = {nbr: rowNbr, type: "BDG", shelf: []};
                this.achievementArr.push(achievementObj);
                rowNbr += 1;
            }
            const lastChar = badgesList[i].badgeCode.length - 1;
            let currentBadgeCode = badgesList[i].badgeCode.substring(0,lastChar);
            let findBadgeCode = badgesList[i].badgeCode;
            const badgeObj = 
                    this.gameInfo.gameData.badgesEarned.find(elem => elem.badgeCode === findBadgeCode);
            if (badgeObj){
                badgePartCount += 1;
                fullBadgeCode = badgeObj.badgeCode;
            }
        
            if (prevBadgeCode === currentBadgeCode ){
                let badgeEarned = "";
                if (badgePartCount === this.state.badgesPerTopic){
                    badgeEarned = true;
                }else{
                    if (badgePartCount >= 1){
                        badgeEarned = "partial";
                    }else{  
                        fullBadgeCode = findBadgeCode;
                        badgeEarned = false;
                    }
                }
                const imgSrc = "./assets/Awards/" + badgesList[i].pictureName;
                shelfObj = {id: fullBadgeCode, earned: badgeEarned, imgSrc: imgSrc};
                achievementObj.shelf.push(shelfObj);
                badgePartCount = 0;
                fullBadgeCode = "";
            }else{
                prevBadgeCode = currentBadgeCode;
            }
        }
        let nbrBadgesEarned = this.gameInfo.gameData.badgesEarned.length / 2;
        this.displayEarnBadgeButton = true;
        if (nbrBadgesEarned >= this.state.maxNbrBadges){
            this.displayEarnBadgeButton = false;
        }
    }

    processAchievements(){
        const achievementList = AchievementsDataset;
        let rowNbr = 2;
        let achievementObj = {};
        let achievementEarnedObj = {};
        let shelfObj = {};
        let imgSrc = "";
        let medalType = "";
        for (let i=0; i<achievementList.length; i++){
            const checkRow = (rowNbr - 2) * this.state.nbrPerRow;
            if (i === checkRow){
                const type = achievementList[i].achievementID.substring(0,1);
                const medalImgObj = getTrophyInfo(type);
                imgSrc = medalImgObj.imgSrc;
                medalType = medalImgObj.medalType;
                achievementObj = {nbr: rowNbr, type: type, shelf: []};
                this.achievementArr.push(achievementObj);
                rowNbr += 1;
            }
            achievementEarnedObj = this.gameInfo.gameData.achievementArr.find(elem => 
                        elem.achievementID === achievementList[i].achievementID);
            
            shelfObj = {id: achievementList[i].achievementID, earned: "", imgSrc: "", medalType: ""};
            if (achievementEarnedObj && achievementEarnedObj.earned === true){
                shelfObj.earned = true;
            }else{
                shelfObj.earned = false;
            }
            shelfObj.imgSrc = imgSrc;
            shelfObj.medalType = medalType;
            achievementObj.shelf.push(shelfObj);
             
        }
        if (achievementEarnedObj){
            shelfObj.earned = true;
        }else{
            shelfObj.earned = false;
        }
        shelfObj.imgSrc = imgSrc;
        achievementObj.shelf.push(shelfObj);
    }

    displayAwardInfo(awardSlctd, awardType){
       
        this.achievementSlctd = awardSlctd;
        this.achievementType = awardType;
        this.setState({openAwardInfo: true});
    }

    closeAwardInfo(){
        this.setState({openAwardInfo: false});
    }

    render() {
        this.processingDoneSw = true;
        const awardDisplay = this.achievementArr.map((awards,index) =>
            <AwardImageCard key={index} awards={awards} 
                displayAwardInfo={(awardSlctd, awardType) => 
                    this.displayAwardInfo(awardSlctd, awardType)}
               />
            );  
    return <>
      {!this.processingDoneSw ?  
            <WaitTimeSpinner />
      :   
      <Modal show={this.props.modalOpen}  onHide={() => this.props.onClose()} size="md" 
        scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton >
            <Modal.Title>
                <div >Awards You've Earned</div>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body >
          
            <div style={{ overflowX: 'hidden' }}>
                <img className="" src="./assets/Awards/shelvesTop.png" 
                    alt="trophy"/>            
                {awardDisplay}  
                <img className="" src="./assets/Awards/shelvesBottom.png" 
                    alt="trophy"/>         
            </div>

            {this.state.openAwardInfo   ?
                <AwardInfoModal
                    modalOpen={this.state.openAwardInfo}
                    gameInfo={this.props.gameInfo}
                    achievementType={this.achievementType}
                    onNavigate={(pathname) => this.props.onNavigate(pathname)}
                    achievementSlctd={this.achievementSlctd}
                    onClose={() => this.closeAwardInfo()}
                />
            :
                null
            }
        </Modal.Body>
        <Modal.Footer className="p-0 backgroundTopBottom">
            <span className="font-weight-bold">
                <div className="text-denter">{this.message1}</div>
                <div className="mx-4">{this.message2}</div>
            </span>
            {this.displayEarnBadgeButton   ?
                <Button variant="primary"  onClick={() => this.props.onClose("earn-badge")}>
                      Badge Challenge
                </Button>
            : null
            }
            <Button variant="secondary"  onClick={() => this.props.onClose("none")}>
                      Close
            </Button>
        </Modal.Footer>
        </Modal>
       }
        </>
    }
    
    componentDidMount(){
        this._isMounted = true;
    }

    componentWillUnmount(){
        this._isMounted = false;
   }
     
}

export default AwardModal;